/**
 * Pool of fake usernames used for procedural author identities. Curated
 * for a pixel-game / dark-fantasy aesthetic; lowercase, ≤10 chars so the
 * persistent HUD badge stays narrow. Variant B only.
 */
export const AUTHOR_NAME_POOL: readonly string[] = [
  "leafstomp42",
  "kithmoth",
  "runedrip",
  "sablefen",
  "voxworm",
  "hexpenny",
  "silknail",
  "graydusk",
  "motheater",
  "brassrune",
  "pithwick",
  "candlefly",
  "geo_gretch",
  "slatehowl",
  "ravenpip",
  "copperaxe",
  "halfgrim",
  "frostquill",
  "dimspine",
  "mosskind",
  "tinglow",
  "junipernox",
  "willowpyre",
  "ashenfoot",
  "marrowink",
  "soothglass",
  "fernstride",
  "duskmote",
  "pebblewise",
  "ladybones",
  "fogspark",
  "tideloom",
  "ironpod",
  "hollowmint",
  "vellumcat",
  "thornlace",
  "earlybell",
  "snailcairn",
  "barrowfen",
  "redfern",
  "hushmoon",
  "tallowknit",
  "smokecreek",
  "rookberry",
  "ravelash",
  "owlclasp",
  "ferrybrook",
  "wickerwax",
  "glimmersaw",
  "saltcobble",
];
